import { PolylineMeasurementDetails } from './PolylineMeasurementDetails';
import { PolylineMeasurementOptions } from './PolylineMeasurementOptions';
import { createPolylineMeasurementController } from './polyline-measurement-controller';

export const polylineMeasurementConfig = {
  detailsComponent: PolylineMeasurementDetails,
  optionsComponent: PolylineMeasurementOptions,
  createController: createPolylineMeasurementController,
};

export type {
  PolylineDetailsProps,
  PolylineMeasurementController,
} from './polyline-measurement.types';
export type { PolylineMeasurementDetailsProps } from './PolylineMeasurementDetails';
export type { PolylineMeasurementOptionsProps } from './PolylineMeasurementOptions';
export {
  PolylineMeasurementDetails,
  PolylineMeasurementOptions,
  createPolylineMeasurementController,
};
